import { buildCommonFilters, embedFilter, labeledMapItem } from '../sharedFilters'

const DATASET_KEY = 'dmp_panel_devices'

// Same broken units branch as the other dmp datasets (500 server-side), so
// installation, estado and municipio are not offered; sectors/centers join
// directly off dmp_panels and do work. dmp_panel_devices.status is a raw JSON
// blob ({"status": "NORMAL"}), unusable as chart labels — the boolean `active`
// is the device status offered instead. The default now-30d window is safe
// here: updated_at is refreshed by the panel sync, so the whole inventory
// stays inside it (measured: 47 of 47 devices within the last 30 days).
const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: false,                           // units branch: 500 server-side
  REGION: false,                                 // units branch: 500 server-side
  MUNICIPALITY: false,                           // units branch: 500 server-side
  SECTOR: {},                                    // sectors.name (via dmp_panels.id_sector)
  CENTER: {},                                    // centers.name (via dmp_panels.id_center)
  TENANT: {},                                    // tenants.name (via dmp_servers.id_tenant)
  STATUS: false,                                 // dmp_panel_devices.status is a JSON blob
  USER: false,                                   // no users join
})

const ACTIVE_LABELS = { 0: 'Inactivo', 1: 'Activo' }
const ACTIVE_MAPPING = JSON.stringify({
  'dmp_panel_devices.active': ACTIVE_LABELS,
  active: ACTIVE_LABELS,
})

export default {
  key: DATASET_KEY,
  label: 'Dispositivos DMP',
  timeColumn: 'dmp_panel_devices.updated_at',
  permission: { action: 'read', subject: 'Dmp' },

  tables: {
    dmp_panel_devices: ["id", "name", "type", "device_type", "source_id", "status", "active", "dmp_panel_area_id", "dmp_panel_id", "id_device_tag", "virtual_bypass", "created_at", "updated_at"],
    dmp_panels: ["id", "name", "id_sector", "id_center", "id_dmp_server"],
    dmp_panel_areas: ["id", "source_id", "name", "active", "dmp_panel_id"],
    device_tags: ["id", "name", "device_type", "id_tenant"],
    dmp_servers: ["id", "name", "id_tenant"],
    sectors: ["id", "id_center", "name"],
    centers: ["id", "name"],
    tenants: ["id", "name"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'dmp_panel_devices.type',
  },

  csvConfig: {
    columns: 'dmp_panel_devices.name,dmp_panel_devices.type,dmp_panel_devices.device_type,dmp_panel_devices.source_id,dmp_panel_devices.active,dmp_panels.name,dmp_panel_areas.name,device_tags.name,sectors.name,centers.name,dmp_panel_devices.updated_at',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'dmp_panel_devices.type', label: 'Tipo' },
    { key: 'dmp_panel_devices.active', label: 'Estatus', defaultParams: { mapping: ACTIVE_MAPPING } },
    { key: 'dmp_panels.name', label: 'Panel' },
    { key: 'device_tags.name', label: 'Etiqueta' },
    { key: 'dmp_panel_areas.name', label: 'Área' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'dmp_panel_devices.updated_at', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'dmp_panel_devices.type', 'Tipo', 'type'),
    // device_type is the vendor label (Keypad, Door…) and is null on most rows
    // (35 of 47 measured) — offered as a filter, not as a grouping field.
    embedFilter(DATASET_KEY, 'dmp_panel_devices.device_type', 'Tipo de dispositivo', 'device_type'),
    embedFilter(DATASET_KEY, 'dmp_panel_devices.active', 'Estatus', 'active', {
      optionsOverrides: { mapItem: labeledMapItem(ACTIVE_LABELS) },
    }),
    embedFilter(DATASET_KEY, 'dmp_panels.name', 'Panel', 'group'),
    embedFilter(DATASET_KEY, 'device_tags.name', 'Etiqueta', 'tag'),
    embedFilter(DATASET_KEY, 'dmp_panel_areas.name', 'Área', 'area'),
  ],

  dateGrouping: {
    column: 'dmp_panel_devices.updated_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
